exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title {\r\n    font-size: 40px;\r\n    text-align: center;\r\n    font-weight: bold;\r\n}\r\n\r\n.sub-title {\r\n    font-size: 30px;\r\n    text-align: center;\r\n    margin-top: 10px;\r\n}\r\n\r\n.printed-date {\r\n    font-size: 16px;\r\n    text-align: center;\r\n}\r\n\r\n.spacer {\r\n    margin-bottom: 50px\r\n}\r\n\r\n.asset-table {\r\n    margin-left: 30px;\r\n}\r\n\r\n.member-name {\r\n    font-weight: bold;\r\n}\r\n\r\n.member-address {\r\n    font-weight: bold;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// c:/Projects/CCLibrary/Client/src/app/overdue-report/overdue-report.component.css
// module id = ../../../../../src/app/overdue-report/overdue-report.component.css
// module chunks = 1